import TopPanel from '../TopPanel';
import gameClient from '../../infrastructure/gameClient';
import { useLoggedUserContext } from '../../AppContext';
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import UIError from "../UIError";
import ErrorPopup from "../error/ErrorPopup";
import GameServerPanel from './GameServerPanel';

export default function AdminView() {
    const navigate = useNavigate();
    const setLoggedUser = useLoggedUserContext()[1];
    const serversQuery = useQuery({
        queryKey: ["servers"],
        queryFn: async () => await fetchServers(),
    });

    return <>
        <TopPanel/>
        {serversQuery.isError && renderError(serversQuery.error, setLoggedUser, navigate)}
        {serversQuery.isPending && <div>Loading ...</div>}
        {serversQuery.isSuccess && renderServers(serversQuery.data)}
    </>
}

async function fetchServers() {
    const res = await gameClient.getServers();

    if (res.ok) {
        return await res.json();
    }

    if (res.status === 401) {
        throw new UIError("UNAUTHORIZED");
    }

    throw new UIError("Error status code: " + res.status);
};

function renderServers(servers) {
    return <div style={{paddingTop: "60px", paddingLeft: "20px"}}>
        {servers.map(s => <GameServerPanel key={s.id} gameServer={s}/>)}
    </div>
}

function renderError(error, setLoggedUser, navigate) {
    if (error.name === "UIError" && error.message === "UNAUTHORIZED") {
        setTimeout(() => {
            setLoggedUser(null);
            navigate('/login');
        });
        return null;
    }

    return <ErrorPopup message={error.message}/>
}
